
import React from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { closeEditor } from "@redux/slices/userEditorSlice";
import ViewModalUpdate from "settings/account/components/Users/ViewModalUpdate";
import { markUsersDirty } from "@redux/slices/usersListSlice";

export default function UserEditorHost() {
  const dispatch = useAppDispatch();
  const { isOpen, userId } = useAppSelector((s) => s.userEditor);

  if (!isOpen) return null;

  return (
    <ViewModalUpdate
      id={userId}
      setID={() => dispatch(closeEditor())}
      fetchUsers={async () => {
        // Tell any listeners (e.g., UsersPage) to refresh
        dispatch(markUsersDirty(true));
      }}
    />
  );
}
